// Get Batch Message Variables
export const GET_BATCH_MESSAGE_VARIABLES_REQUEST = 'GET_BATCH_MESSAGE_VARIABLES_REQUEST';
export const GET_BATCH_MESSAGE_VARIABLES_DONE = 'GET_BATCH_MESSAGE_VARIABLES_DONE';
export const GET_BATCH_MESSAGE_VARIABLES_FAILED = 'GET_BATCH_MESSAGE_VARIABLES_FAILED';
export const GET_BATCH_MESSAGE_VARIABLES_RESET = 'GET_BATCH_MESSAGE_VARIABLES_RESET';

// Operations
export const BATCH_MESSAGE_VARIABLES_SET_PAGE = 'BATCH_MESSAGE_VARIABLES_SET_PAGE';